import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

type MemberTimelineFilters = {
  itemTypeIn: string[]
  direction: string[]
}

type MemberTimelineFiltersStoreState = {
  memberTimelineFilters: MemberTimelineFilters
  setMemberTimelineFilters: (filters: MemberTimelineFilters) => void
}

export const useMemberTimelineFiltersStore = create<MemberTimelineFiltersStoreState>()(
  persist(
    set => ({
      memberTimelineFilters: { itemTypeIn: [], direction: [] },
      setMemberTimelineFilters: filters =>
        set(() => ({
          memberTimelineFilters: {
            ...filters,
          },
        })),
    }),
    {
      name: 'memberTimelineFilters-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
